module.exports = __webpack_public_path__ + "static/media/marketo-video.b479317e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/marketo-video.png
// module id = hPkC
// module chunks = 89